@use "../../../../shared/scss/index" as *;

:host {
  .form-container {
    display: flex;
    flex-direction: column;
    gap: $pds-spacing-fluid-small;
  }

  &.skeleton {
    pointer-events: none;
    user-select: none;

    & .skeleton-autocomplete-search-field {
      inline-size: auto;
      block-size: p-px-to-rem(54px);
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;
    }
  }

  .animate-out {
    animation: fadeOutToTop 0.75s ease-in-out 0s;
  }

  .input-container {
    inline-size: 100%;

    phn-nd-autocomplete-search-field {
      display: block;
    }
  }

  .spinner {
    display: flex;
    position: relative;
    justify-content: center;
    inline-size: 100%;
    margin-block-start: p-px-to-rem(24px);
  }
}
